import React from 'react';
import { motion } from 'framer-motion';
export function Revelation() {
  return <section className="py-16 md:py-24 bg-matrix-black relative overflow-hidden px-4" data-id="element-155">
      <div className="absolute top-0 right-0 w-full md:w-1/2 h-full bg-[url('https://images.unsplash.com/photo-1526374965328-7f61d4dc18c5?q=80&w=2070&auto=format&fit=crop')] bg-cover bg-center opacity-10 mix-blend-screen" data-id="element-156"></div>
      <div className="absolute inset-0 bg-gradient-to-t md:bg-gradient-to-r from-matrix-black via-matrix-black/90 to-transparent" data-id="element-157"></div>

      <div className="max-w-5xl mx-auto relative z-10 flex flex-col md:flex-row items-center gap-12" data-id="element-158">
        <div className="flex-1 order-2 md:order-1" data-id="element-159">
          <motion.div initial={{
          opacity: 0,
          x: -50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-160">
            
            <h2 className="font-cinzel text-3xl md:text-5xl text-matrix-cream mb-6 md:mb-8 leading-tight" data-id="element-161">
              La realidad no es lo que te dijeron
            </h2>
            <div className="space-y-4 md:space-y-6 text-matrix-white text-base md:text-lg font-light" data-id="element-162">
              <p data-id="element-163">
                A veces, lo que necesitas no es seguir haciendo más de los
                mismo, sino detenerte a observar, cuestionar y despertar. Lo que
                llamas "Vida" es en realidad un sistema, un juego, una
                estructura codificada diseñada para mantenerte en un bucle
                impredecible.
              </p>
              <p data-id="element-164">
                Desde que naces, te instalan un software: creencias, miedos,
                deseos artificiales y limitaciones que no son tuyas. Te enseñan
                a jugar según sus reglas. Este ebook puede ayudarte a abrir una
                nueva conversación contigo mismo, con tu historia y con la forma
                en que estas viviendo tu realidad.
              </p>
              <p className="text-matrix-green font-medium text-lg md:text-xl border-l-2 border-matrix-green pl-4 md:pl-6 py-2" data-id="element-165">
                Estás aquí para despertar, observar los patrones ocultos y
                recuperar el control del "código fuente" de tu propia
                existencia.
              </p>
            </div>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.8
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 1
      }} className="flex-1 flex justify-center relative order-1 md:order-2" data-id="element-166">
          
          <div className="absolute inset-0 bg-matrix-green blur-[100px] opacity-10 rounded-full" data-id="element-167"></div>
          <div className="relative w-56 h-56 md:w-80 md:h-80 border border-matrix-green/30 rounded-full flex items-center justify-center p-6 md:p-8" data-id="element-168">
            <div className="absolute inset-0 border border-matrix-green/20 rounded-full animate-[spin_10s_linear_infinite]" data-id="element-169"></div>
            <div className="absolute inset-4 border border-matrix-green/40 rounded-full animate-[spin_15s_linear_infinite_reverse]" data-id="element-170"></div>
            <div className="text-center" data-id="element-171">
              <span className="font-cinzel text-xl md:text-2xl text-matrix-cream block mb-1 md:mb-2" data-id="element-172">
                EL SISTEMA
              </span>
              <span className="text-matrix-green text-xs md:text-sm tracking-[0.2em] md:tracking-[0.3em]" data-id="element-173">
                DESCODIFICADO
              </span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}